var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.type === 'link')?_c('router-link',{staticClass:"pp-btn item-center pointer",class:{
      active: _vm.isActive,
      disabled: _vm.isDisabled
    },style:(_vm.ovStyle),attrs:{"to":_vm.linkTo},on:{"click":_vm.onClick}},[_vm._t("default")],2):_vm._e(),(_vm.type === 'btn')?_c('div',{staticClass:"pp-btn item-center pointer",class:{
      active: _vm.isActive,
      disabled: _vm.isDisabled
    },style:(_vm.ovStyle),on:{"click":_vm.onClick}},[_vm._t("default")],2):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }